<script setup lang="ts">
import MedicationCheckupCopiloteLine from "@/medication-checkup/components/MedicationCheckupCopiloteLine.vue";
import MedicationCheckupUserEcho from "@/medication-checkup/components/MedicationCheckupUserEcho.vue";
import MedicationCheckupCopiloteBubble from "@/medication-checkup/components/MedicationCheckupCopiloteBubble.vue";
import MedicationCheckupSceneReplies from "@/medication-checkup/components/MedicationCheckupSceneReplies.vue";
import {IntroductionView} from "@/medication-checkup/interfaces/introduction";
import {SceneProps} from "@/medication-checkup/composables/useScene";
import {useDoorstepScene} from "@/medication-checkup/composables/useDoorstepScene";

/**
 * The scene of the doorstep of the advice interview: the first scene of the
 * third step, held with the patient again once the doctor has answered.
 *
 * Its bubble counts the changes the analysis finally settled, and the one
 * action starts the interview. All of it is served by the handler of the
 * block; the scene owns the rendering only, and plays the same mechanic as
 * the other doorsteps.
 */

const props = defineProps<SceneProps<IntroductionView>>();

const {bubbleShown, repliesShown, clicked, text, actions, acted, act} = useDoorstepScene(props);
</script>

<template>
  <div class="flex flex-col gap-3.5">
    <template v-if="frozen">
      <MedicationCheckupCopiloteLine v-if="text" :text="text" />
      <MedicationCheckupUserEcho v-if="acted" :text="acted" />
    </template>

    <template v-else>
      <MedicationCheckupCopiloteBubble
        :shown="bubbleShown"
        :text="text"
      />

      <MedicationCheckupSceneReplies
        :clicked="clicked"
        :actions="actions"
        :shown="repliesShown"
        @act="act"
      />
    </template>
  </div>
</template>
